import React from 'react'

import { object, string, bool, arrayOf, shape } from 'prop-types'

import { EMPTY_ARRAY, EMPTY_OBJECT } from 'Utils/stableDefaults'

import GenerationToast from './Components/GenerationToast/GenerationToast'
import Hamburger from './Components/Hamburger/Hamburger'
import Logo from './Components/Logo/Logo'
import Menu from './Components/Menu/Menu'
import Search from './Components/Search/Search'
import UserActions from './Components/UserActions/UserActions'
import { useHamburgerStatus } from './Hooks/useHamburgerStatus'

function Navigation({
  commonRoutes,
  mainMenuItems = EMPTY_OBJECT,
  communityLinks = EMPTY_ARRAY,
  createAiLinks = EMPTY_ARRAY,
  createAiGeneration = EMPTY_OBJECT,
  showFreeTrialTag = false,
  actionsLinks = EMPTY_ARRAY,
  actionsConfig = EMPTY_OBJECT,
  locale = 'en',
  isInListingPage = false,
  searchInputValue = '',
  searchPlaceholder,
  currentUserId = null,
}) {
  const { root } = commonRoutes
  const { isActive, toggle } = useHamburgerStatus()

  // Same server-translated label the Create with AI tag renders (createAiLinks[].tag),
  // reused for the user-menu Subscription pill so both read one source. Client i18n is
  // intentionally not used here - these nav labels are translated server-side.
  const freeTrialLabel = createAiLinks.find((link) => link.tag)?.tag

  return (
    <div className="unified-nav">
      {isActive && (
        <button
          type="button"
          className="unified-nav__backdrop"
          onClick={toggle}
          aria-label="Close menu"
        />
      )}
      <Hamburger isActive={isActive} onToggle={toggle} />
      <Logo url={root} />
      <Search
        locale={locale}
        isInListingPage={isInListingPage}
        searchInputValue={searchInputValue}
        searchPlaceholder={searchPlaceholder}
      />
      <Menu
        isActive={isActive}
        mainMenuItems={mainMenuItems}
        communityLinks={communityLinks}
        createAiLinks={createAiLinks}
        createAiGeneration={createAiGeneration}
        showFreeTrialTag={showFreeTrialTag}
        locale={locale}
        currentUserId={currentUserId}
      />
      <UserActions
        actionsLinks={actionsLinks}
        actionsConfig={actionsConfig}
        locale={locale}
        showFreeTrialTag={showFreeTrialTag}
        freeTrialLabel={freeTrialLabel}
      />
      <GenerationToast labels={createAiGeneration} currentUserId={currentUserId} />
    </div>
  )
}

Navigation.propTypes = {
  commonRoutes: object.isRequired,
  mainMenuItems: object,
  communityLinks: arrayOf(shape({
    href: string,
    trackText: string,
    title: string,
    icon: string,
  })),
  createAiLinks: arrayOf(shape({
    id: string,
    href: string,
    title: string,
    trackText: string,
    icon: string,
    tag: string,
  })),
  createAiGeneration: shape({
    readyTitle: string,
    openModel: string,
    errorTitle: string,
    errorHref: string,
    dismiss: string,
  }),
  showFreeTrialTag: bool,
  actionsLinks: arrayOf(shape({
    id: string,
    href: string,
    icon: string,
  })),
  actionsConfig: shape({
    isCurrentUser: bool,
    newRoyaltyUi: bool,
  }),
  locale: string,
  isInListingPage: bool,
  searchInputValue: string,
  searchPlaceholder: string.isRequired,
  currentUserId: string,
}

export default Navigation
